export enum BehaviorTypesEnum {
    Navigation = "navigation",
    ToggleDisplay = "toggledisplay",
    CreateDocument = "createdocument",
    CreateInfectionReport = "createinfectiondocument",
    AddItem = "additem",
    DeleteItem = "deleteitem",
    Prefill = "prefill",
    ClearTargetOnValueChange = "cleartargetonvaluechange",
    Permission = "permission",
    ReadOnlyIf = "readonlyif",
    CountListGroupItems = "countlistgroupitems",
    CountListGroupItemsProperty = "countlistgroupitemsproperty", // Behavior keeps count of specific property within a list group.
    SumPropertyDifferenceBehavior = "sumpropertydifference", // Behavior calculates total amount of hours in a list group time range.
    Get = "get",
    GetMultiTarget = "get-multi-target",
    GetWoundGroup = "getwoundgroup",
    LoadNarrative = "load-narrative",
    Formula = "formula",
    UpdateTarget = "updatetarget"
}
